import React from 'react';
import PropTypes from 'prop-types';

import {
  ArticleLeaderboardItem,
  ImageLeaderboardItem,
  LeaderboardItemBody,
  LeaderboardItemEmail,
  LeaderboardItemHeader,
  LeaderboardItemName,
  LeaderboardItemScore,
} from '../../styled';

const LeaderboardItem = ({
  user,
  score,
}) => {
  const { name, email, avatar } = user;

  return (
    <ArticleLeaderboardItem>
      <LeaderboardItemHeader>
        <ImageLeaderboardItem src={avatar} alt="Avatar" />
        <LeaderboardItemBody>
          <LeaderboardItemName>
            @
            {name}
          </LeaderboardItemName>
          <LeaderboardItemEmail>{email}</LeaderboardItemEmail>
          <LeaderboardItemScore>
            Score:
            &nbsp;
            {score}
          </LeaderboardItemScore>
        </LeaderboardItemBody>
      </LeaderboardItemHeader>
    </ArticleLeaderboardItem>
  );
};

const userShape = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
};

const leaderboardItemShape = {
  user: PropTypes.shape(userShape).isRequired,
  score: PropTypes.number.isRequired,
};

LeaderboardItem.propTypes = {
  ...leaderboardItemShape,
};

export { leaderboardItemShape };
export default LeaderboardItem;
